import {useRefractoryCatalogFilterOptionsQuery as useRefractoryCatalogFilterOptionsQueryBase} from '@domain/refractory-product-catalog'
import {spawnErrorToast} from '@hm/fundamental'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {logger} from '../utils'

export const useRefractoryCatalogFilterOptionsQuery = (): ReturnType<
  typeof useRefractoryCatalogFilterOptionsQueryBase
> => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const query = useRefractoryCatalogFilterOptionsQueryBase()

  useEffect(() => {
    if (query.isError) {
      logger
        .context('useRefractoryCatalogFilterOptionsQuery')
        .extras({errorDetails: query.error?.message})
        .error('Error occurred while fetching refractory catalog filter options')

      spawnErrorToast(t('error.refractoryCatalogFilterOptionsQuery'))
    }
  }, [query.isError, query.error, t])

  return query
}
